import { Check } from "lucide-react";
import { useImageModelStore } from "@/store/imageModelStore";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const InlineImageModelSelect = () => {
  const { selectedModel, setSelectedModel, getEnabledModels } =
    useImageModelStore();

  // Get only enabled generation models
  const imageModels = getEnabledModels("generation");

  // Group models by provider
  const modelsByProvider = imageModels.reduce((acc, model) => {
    if (!acc[model.provider]) {
      acc[model.provider] = [];
    }
    acc[model.provider].push(model);
    return acc;
  }, {});

  // Get current model details
  const currentModel = imageModels.find((m) => m.id === selectedModel);

  return (
    <Select value={selectedModel} onValueChange={setSelectedModel}>
      <SelectTrigger className="h-[26px] min-w-[120px] max-w-[280px] border-[#2563eb]/30 dark:border-[#99CEFF]/20 bg-[#2563eb]/10 dark:bg-[#99CEFF]/10 hover:bg-[#2563eb]/20 dark:hover:bg-[#99CEFF]/20 text-[#2563eb] dark:text-[#99CEFF] transition-colors duration-150">
        <SelectValue>
          <div className="flex items-center gap-1.5 min-w-0">
            <Check className="h-3 w-3 text-[#2563eb] dark:text-[#99CEFF] flex-shrink-0" />
            <span className="text-xs font-medium truncate">
              {currentModel?.name || "Select model"}
            </span>
          </div>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-[300px] z-[100000]">
        {Object.entries(modelsByProvider).map(([provider, models]) => (
          <SelectGroup key={provider}>
            <SelectLabel className="text-xs font-semibold text-gray-500 dark:text-gray-400 px-2 py-1.5">
              {provider.toUpperCase()}
            </SelectLabel>
            {models.map((model) => (
              <SelectItem key={model.id} value={model.id} className="text-xs">
                <div className="flex items-center justify-between w-full">
                  <span>{model.name}</span>
                  {model.id === selectedModel && (
                    <Check className="h-3 w-3 text-green-500 ml-2" />
                  )}
                </div>
              </SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
};
